/**
 * The three widths a back-office page can have, and the rule that picks one.
 * The width follows the *kind* of page, so the same kind of page has the same
 * width everywhere, and pages that are siblings in the sidebar never change
 * width when you go from one to the next:
 *
 * - `default` — a list, a table, a dashboard: what the sidebar opens in
 *   Activité, Ressources, Canaux, and the agents list.
 * - `medium` — settings (every page of the "Entreprise" group, the tools and a
 *   tool's page) and the file of one record (a contact, an agent, a number
 *   request). A settings page mixes forms and tables, and a form in
 *   `SettingsSection` needs room for its label column.
 * - `narrow` — one form on its own, reached from somewhere else with `backTo`
 *   (editing a contact or an agent, a qualification form), and the personal
 *   account pages.
 *
 * The page frame caps the width; never cap it again inside the page — a
 * content narrower than its header no longer lines up with it.
 */
export const PAGE_WIDTHS = {
  narrow: "max-w-3xl",
  medium: "max-w-5xl",
  default: "max-w-7xl",
} as const;

export type PageWidth = keyof typeof PAGE_WIDTHS;
